import { API } from '../../constant/apiConstant';
async function request(path, token, options = {}) {
  const submission = path === '/api/upload/kyc/update' && options.method === 'POST';
  let response;
  try { response = await fetch(`${API.BASE_URL}${path}`, {
    credentials: 'include', ...options,
    headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}), ...options.headers }
  }); } catch (_) { throw new Error(submission ? 'Connection interrupted. Submission may not be confirmed; check request history before retrying.' : 'Connection interrupted. Please retry.'); }
  const data = await response.json().catch(() => null);
  if(response.status===401) throw new Error(`${data?.message || 'Session expired'}. Sign in again, then check request history before retrying.`);
  if (!response.ok || !data || data.status === false) throw new Error(data?.message || 'Unable to load profile information. Please retry.');
  return data;
}
export const ProfileKYCService = {
  getProfileKYC: token => request('/api/profile-kyc/', token),
  getBanks: () => request('/api/profile-kyc/banks'),
  getRequests: token => request('/api/profile-kyc/requests', token),
  sendEmailCodes:(token,id,password)=>request(`/api/profile-kyc/requests/${id}/email/send`,token,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({password})}),
  verifyEmailCode:(token,id,kind,code)=>request(`/api/profile-kyc/requests/${id}/email/verify`,token,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({kind,code})}),
  submitKYC: (token, payload) => request('/api/upload/kyc/update', token, {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload)
  })
};
